import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from "react-error-boundary";
import { BottomSheetErrorBoundaryFallback } from "./BottomSheetErrorBoundaryFallback";
export function BottomSheetErrorBoundary(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ErrorBoundary fallbackRender={_temp}>{children}</ErrorBoundary>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(props) {
  return <BottomSheetErrorBoundaryFallback {...props} />;
}